import React from 'react';
import PropTypes from 'prop-types';

import AccessButton from '../common/AccessButton';
import DateString from '../common/DateString';

const propTypes = {
    project: PropTypes.object.isRequired
};

const defaultProps = {};

function ProjectTile(props) {
    return (
        <div className="tile project-tile">
            <h3 className="tile-title" title={props.project.name}>{props.project.name}</h3>
            <div className="tile-info">
                <div className="tile-info-label">
                    Date created
                </div>
                <div className="tile-info-data">
                    <DateString date={props.project.created_at}/>
                </div>
                <div className="tile-info-label">
                    Date modified
                </div>
                <div className="tile-info-data">
                    { !!props.project.modified ?
                        <DateString date={props.project.modified}/>
                        :
                        'Never'
                    }
                </div>
                <div className="inline-block">
                    <div className="tile-info-label">
                        Activities
                    </div>
                    <div className="tile-info-data large">
                        <span title="Total">{props.project.activity_count}</span> <span className="tile-info-label-color">/</span> <span title="Published">{props.project.published_activity_count}</span>
                    </div>
                </div>
            </div>
            <div className="tile-actions">
                <AccessButton
                    href={`/project/${props.project.channelId}/${props.project.id}`}
                    iconPath={`${GlobalConfig.StaticUrl}/img/Open.svg`}
                    iconStyle={{width:'35px'}}
                    text="Open Project"
                />
            </div>
        </div>
    );
}

ProjectTile.propTypes = propTypes;
ProjectTile.defaultProps = defaultProps;

export default ProjectTile;